import Marionette from 'backbone.marionette';
import billDetailStatusCollectionview from './bill_detail_status_itemview';
export default Marionette.CollectionView.extend({
  childView: billDetailStatusCollectionview,
  tagName: "table",
  className: "table"
});